(() => {
  document.querySelectorAll('[data-story-version="pdp-additional-67"]').forEach(root=>{
    root.querySelector('.alpine-story-wear').id='family-details-'+root.dataset.productId;
    const params=new URL(location.href).searchParams;
    const context=params.get('presentation')==='men'?'men':'women';
    root.querySelectorAll('[data-additional-style-link]').forEach(link=>{
      const url=new URL(link.href);url.searchParams.set('presentation',context);url.searchParams.delete('variant');link.href=url.pathname+url.search;
      link.querySelector('img').src=link.dataset[context+'Src'];
    });
  });
})();


(()=>{document.querySelectorAll('[data-goggle-lenses]').forEach(root=>{const buttons=[...root.querySelectorAll('[data-lens-select]')];buttons.forEach(button=>button.addEventListener('click',()=>{buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-lens-panel]').forEach(p=>{p.hidden=p.dataset.lensPanel!==button.dataset.lensSelect;});}));});})();
